import { useAtom } from 'jotai';
import { atomFamily } from 'jotai-family';
import { atomWithStorage } from 'jotai/utils';

import type { VariableItem } from './LibraryItems';

export type LibraryView =
    | 'overview'
    | 'variables'
    | 'reusable-contents'
    | 'files'
    | 'images'
    | 'tags';

export type ViewMode = 'list' | 'grid';

type LibraryNavigationState = {
    view?: LibraryView;
    reusableContents?: {
        spaceId?: string;
        sortBy?: 'updated' | 'name';
        sortDirection?: 'asc' | 'desc';
    };
    variables?: {
        itemType?: VariableItem['type'];
        sortBy?: 'name';
        sortDirection?: 'asc' | 'desc';
    };
    files?: {
        sortBy?: 'name' | 'size' | 'updated';
        sortDirection?: 'asc' | 'desc';
    };
    images?: {
        sortBy?: 'name' | 'size' | 'updated';
        sortDirection?: 'asc' | 'desc';
        viewMode?: ViewMode;
    };
    tags?: {
        sortBy?: 'name' | 'updated';
        sortDirection?: 'asc' | 'desc';
    };
};

/**
 * Atom storing the navigation state per space.
 */
export const navigationStateAtomFamily = atomFamily((spaceId: string) =>
    atomWithStorage<LibraryNavigationState>(
        `libraryNavigationState__${JSON.stringify(spaceId)}`,
        {},
        undefined,
        { getOnInit: true }
    )
);

/**
 * Returns the library navigation state for a space.
 */
export function useLibraryNavigationState(props: { spaceId: string }) {
    return useAtom(navigationStateAtomFamily(props.spaceId));
}
